import React from "react";

const MyQuotes = () => {
  return <div>MyQuotes</div>;
};

export default MyQuotes;
